import CaruselItem from "./Carousel_Item";
import Slider from "react-slick";
import "./FeaturedCarousel.scss";
import { useState, useEffect } from "react";
import axios from "axios";

const FeaturedCarousel = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .get(
          process.env.REACT_APP_API_URL +
            "hero-carrousel?populate[titleSubTitleImage][populate][0]=ImageLarge&populate[titleSubTitleImage][populate][1]=ImageMedium&populate[titleSubTitleImage][populate][2]=ImageSmall&populate[titleSubTitleImage][populate][3]=Link"
        )
        .then((response) => {
          setData(response.data.data.attributes.titleSubTitleImage);
        });
    };
    fetchData();
  }, []);

  const settings = {
    dots: true,
    speed: 300,
    slidesToShow: 1,
    className: "slide",
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: true,
  };

  return (
    <Slider {...settings}>
      {data.map((data) => (
        <CaruselItem data={data} key={Math.random()} />
      ))}
    </Slider>
  );
};

export default FeaturedCarousel;
